var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
// import * as CryptoJS from "crypto-js";
import styles from "../activate-segment/activate-segment.module.scss";
import { pushSegmentApi } from "src/apis/dashboard";
import Shimmer from "../loader/shimmer";
import ThreeDotsPulse from "./threeDotPulse";
const SegmentDetails = ({ segments, dpAccountId, toggleActiveSegmentModal, checkSum, toggleShowSegmentSuccessModal, toggleShowSegmentPendingModal, }) => {
    const incomeCategory = [
        {
            categoryType: "Below 1Lac",
            name: "Below 1 Lac",
        },
        {
            categoryType: "1Lac-5Lac",
            name: "1 Lac - 5 Lac",
        },
        {
            categoryType: "5Lac-10Lac",
            name: "5 Lac - 10 Lac",
        },
        {
            categoryType: "10Lac-25Lac",
            name: "10 Lac - 25 Lac",
        },
        {
            categoryType: "25Lac-1Cr",
            name: "25 Lac - 1 Cr",
        },
        {
            categoryType: "Above 1Cr",
            name: "Above 1 Cr",
        },
    ];
    const inputRef = useRef([]);
    const activateCheckboxRef = useRef();
    // const checkSumRef = useRef("");
    const selectedIncomeSlab = useRef("");
    const [buttonAnimation, setButtonAnimation] = useState(false);
    const activateButtonRef = useRef();
    const [text, showText] = useState(false);
    const checkButtonEnabled = () => {
        let radioButtonSelected = inputRef.current.some((input) => input.checked);
        if (radioButtonSelected && activateCheckboxRef.current.checked) {
            activateButtonRef.current.disabled = false;
        }
        else {
            activateButtonRef.current.disabled = true;
        }
    };
    useEffect(() => {
        checkButtonEnabled();
    }, []);
    const pushSegment = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            setButtonAnimation(true);
            const response = yield pushSegmentApi(dpAccountId, selectedIncomeSlab.current, checkSum);
            // const response = { data: await getPushSegmentDummyData() };
            if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.body) {
                if (response.data.body.Status == "1") {
                    toggleShowSegmentSuccessModal();
                }
                else {
                    toggleShowSegmentPendingModal();
                }
            }
        }
        catch (err) {
            console.log(err);
        }
        finally {
            setButtonAnimation(false);
            toggleActiveSegmentModal();
        }
    });
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: `${styles.modalHeaderPart}` }, { children: [_jsx("h6", Object.assign({ className: "mb-0 larger" }, { children: "Segment Details" })), _jsx("span", { onClick: toggleActiveSegmentModal, className: "closeIcon" })] })), _jsxs("div", Object.assign({ className: `${styles.modalBodyPart}` }, { children: [_jsx("h6", Object.assign({ className: `${styles.segmentTypeHead}` }, { children: "Active Segments" })), _jsx("ul", Object.assign({ className: `${styles.segmentList} d-flex mt-3` }, { children: Object.entries(segments).map(([key, val]) => {
                            if (val.active === "Y") {
                                return (_jsxs("li", { children: [_jsx("span", { className: "checkMarkIconGrey" }), _jsx("p", Object.assign({ className: "ms-2" }, { children: val.name }))] }));
                            }
                            else if (val.active === "")
                                return _jsx(Shimmer, {});
                            else
                                return _jsx(_Fragment, {});
                        }) })), _jsx("h6", Object.assign({ className: `${styles.segmentTypeHead} mt-32px` }, { children: "Segments To Be Activated" })), _jsx("ul", Object.assign({ className: `${styles.segmentList} d-flex mt-3` }, { children: Object.entries(segments).map(([key, val]) => {
                            if (val.active === "N" && !val.name.includes("Mutual")) {
                                return (_jsxs("li", { children: [_jsx("span", { className: "tickMarkIconBlueThick2" }), _jsx("p", Object.assign({ className: "ms-2" }, { children: val.name }))] }));
                            }
                            else if (val.active === "")
                                return _jsx(Shimmer, {});
                            else
                                return _jsx(_Fragment, {});
                        }) })), _jsx("h6", Object.assign({ className: `${styles.segmentTypeHead} mt-32px` }, { children: "Your Annual Income" })), _jsx("ul", Object.assign({ className: `${styles.incomeCategoryList} d-flex mt-3` }, { children: incomeCategory === null || incomeCategory === void 0 ? void 0 : incomeCategory.map((data, idx) => {
                            var _a;
                            return (_jsx("li", Object.assign({ onClick: (e) => {
                                    inputRef.current[idx].checked = true;
                                    selectedIncomeSlab.current = incomeCategory[idx].categoryType;
                                    checkButtonEnabled();
                                } }, { children: _jsxs("div", Object.assign({ className: `${styles.incomeBox} ${((_a = inputRef.current[idx]) === null || _a === void 0 ? void 0 : _a.checked) ? styles.active : ""}` }, { children: [data.name, _jsxs("label", Object.assign({ className: "customRadio segmentActivationRadio ps-4" }, { children: [_jsx("input", { ref: (input) => {
                                                        inputRef.current[idx] = input;
                                                    }, onClick: () => (inputRef.current[idx].checked = true), type: "radio", name: "radio" }), _jsx("span", { className: "checkmark" })] }))] })) })));
                        }) })), _jsxs("div", Object.assign({ className: `${styles.termCondition} d-flex align-items-start` }, { children: [_jsx("input", { ref: activateCheckboxRef, type: "checkbox", className: "me-2", onChange: () => checkButtonEnabled() }), _jsxs("p", Object.assign({ className: "medium" }, { children: ["I hereby request you to kindly activate my Derivatives segment.\u00A0", _jsxs("span", Object.assign({ onClick: () => showText(true) }, { children: [_jsx("span", Object.assign({ className: `${text ? "d-none" : ""} futText pointer` }, { children: "Read More" })), _jsx("span", Object.assign({ className: `${text ? "" : "d-none"}` }, { children: "I have received & have gone through the Rights & Obligations, Risk Disclosure document, policies & procedures and terms & conditions & have understood and am completely aware of the risks associated with dealing in Derivatives segment. I further undertake that I shall update my income details annually & provide necessary proofs to 5paisa to comply with the extant SEBI / Exchange regulations." }))] }))] }))] })), _jsx("div", Object.assign({ className: `${styles.activateSegmentCtaWrapper}` }, { children: _jsx("button", Object.assign({ className: `${styles.activateSegmentCta} btnType1`, type: "submit", ref: activateButtonRef, onClick: () => pushSegment() }, { children: buttonAnimation ? _jsx(ThreeDotsPulse, {}) : "Activate" })) }))] }))] }));
};
export default SegmentDetails;
